import { Box } from '@material-ui/core';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import React from 'react';

import styles from './styles';
interface IProps {
  classes: any;
}
const Atention = ({ classes }: IProps) => {
  return (
    <Box className={classes.container}>
      <InfoOutlined />
      <p className={classes.text}>
        Atenção: Em páginas de vendas que são abertas a partir de APP&apos;s de redes sociais, links com o atributo html target=&quot;blank&quot;
        podem não funcionar. Recomendamos que o atributo não seja utilizado.
      </p>
    </Box>
  );
};

export default styles(Atention) as any;
